// extracted by mini-css-extract-plugin
module.exports = {"banner":"EmailVerificationBanner_banner__6BoYx","text":"EmailVerificationBanner_text__CbYtw"};